import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useSkeleton } from "../../../hooks/useSkeleton";

import {
  Button,
  MuiThemeProvider,
  TextField,
  createMuiTheme,
} from "@material-ui/core";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import {
  changeValidateProjectStatus,
  getProjectById,
  updateProject,
} from "../../../../api/project";

import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { getNonEmpty } from "../../../../utils/helpers";
import MultiTabBlock from "../../../components/MultiTabBlock";
import GeneralTab from "./GeneralTab";
import DevelopmentTab from "./DevelopmentTab";
import CapexAndOpex from "./CapexAndOpex";
import TransactionTab from "./TransactionTab";
import DataRoomTab from "./DataRoomTab";
import { registerLicense } from '@syncfusion/ej2-base';
import { SERVER_URL } from "../../../../api";
import UploadManualTeaser from "../../../components/UploadManualTeaser";


// Create theme for delete button (red)
const theme = createMuiTheme({
  palette: {
    secondary: {
      main: "#F64E60",
    },
  },
});

function getEmptyProject() {
  return {
    title: null,
    description: "",
    technology: null,
    country: null,
    province: null,
    city: null,
    developmentStatus: null,
    targetPrice: null, // Number
    status: "draft",
    seller: null,
    rtbDate: null,
    codDate: null,
  };
}

export default function EditProjectsPage() {
  registerLicense("Ngo9BigBOggjHTQxAR8/V1JFaF5cX2JCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWXZcc3RdQmFZVUByWkBWYEg=");

  const history = useHistory();
  const {
    isLoading: isLoadingData,
    disableLoading: disableLoadingData,
    ContentSkeleton,
  } = useSkeleton();
  const [openConfirmDialog, setOpenConfirmDialog] = useState(0);

  const projectId = useParams().id;
  const [project, setProject] = useState(getEmptyProject());

  const [buttonKey, setButtonKey] = useState(0);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const [projectColumns, setProjectColumns] = useState([
    "General",
    "Development",
    "Capex and Opex",
    "Transaction",
    "Data Room",
  ]);


  const [descriptionRejected, setDescriptionRejected] = useState("");

  useEffect(() => {
    if (!projectId) {
      disableLoadingData();
      return;
    }

    getProjectById(projectId)
      .then((res) => {
        const title = getNonEmpty(res.data?.developmentStatus?.title);
        const newData = {
          ...res.data,
          technology: res.data?.technology,
          developmentStatus:
            title === "----"
              ? null
              : {
                title: title,
                _id: res.data?.developmentStatus?._id,
              },
        };


        if (res.data?.documents?.docPower !== "" && res.data?.documents?.docPower !== null && !projectColumns.includes("Mandate"))
          setProjectColumns(prev => [...prev, "Mandate"]);


        setProject(newData);
        disableLoadingData();
      })
      .catch((error) => {
        alertError({ error: error, customMessage: "Could not get project." });
        disableLoadingData();
      });
  }, [disableLoadingData, projectId]);

  function saveProject(accept) {
    const copiaProject = { ...project };
    copiaProject.status = accept ? "published" : "draft";

    if (projectId) {
      updateProject(projectId, copiaProject)
        .then((res) => {
          alertSuccess({
            title: "Saved!",
            customMessage: "Changes successfully saved.",
          });
          history.push("/projects");
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "Could not save changes.",
          });
        });
    }
  }

  const renderMultiTabContent = (tabName) => {
    if (tabName === "General") {
      return (
        <>
          <GeneralTab project={project} setProject={setProject} />
          {projectId && (
            <div style={{ marginTop: "24px", padding: "16px", border: "1px solid #e0e0e0", borderRadius: "4px" }}>
              <UploadManualTeaser projectId={projectId} project={project} setProject={setProject} />
            </div>
          )}
        </>
      );
    } else if (tabName === "Development") {
      return <DevelopmentTab project={project} setProject={setProject} />;
    } else if (tabName === "Capex and Opex") {
      return <CapexAndOpex project={project} />;
    } else if (tabName === "Transaction") {
      return <TransactionTab project={project} />;
    } else if (tabName === "Data Room") {
      return <DataRoomTab project={project} />;
    }
    else if (tabName === "Mandate") {
      return (
        <>

          {project?.documents?.docPower &&
            <div style={{ height: "100%" }}>
              <iframe
                type="application/pdf"
                src={`${SERVER_URL}/${project?.documents?.docPower}`}
                width="100%"
                height="580px"
                style={{ border: "1px solid #ccc" }}
              />
            </div >
          }
          {/*} (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", gap: "10px", "marginTop": "100px" }}>
                <div style={{ width: "100px", height: "400px" }}>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
                    <linearGradient id="a11">
                      <stop offset="0" stopColor="#113A7C" stopOpacity="0"></stop>
                      <stop offset="1" stopColor="#113A7C"></stop>
                    </linearGradient>
                    <circle fill="none" stroke="url(#a11)" strokeWidth="15" strokeLinecap="round" strokeDasharray="0 44 0 44 0 44 0 44 0 360" cx="100" cy="100" r="70" transformOrigin="center">
                      <animateTransform type="rotate" attributeName="transform" calcMode="discrete" dur="2" values="360;324;288;252;216;180;144;108;72;36" repeatCount="indefinite"></animateTransform>
                    </circle>
                  </svg>
                </div>
              </div>
            )

          }*/}
        </>
      );
    }

    return null;
  };

  function projectDialog(reason) {
    //if (project.validated || (project.status === "review" && !project.validated)) {
    if (reason) {
      return (
        <TextField
          label="Explain the changes..."
          value={descriptionRejected}
          onChange={(e) => setDescriptionRejected(e.target.value)}
          fullWidth
          margin="normal"
          variant="outlined"
          multiline
          minRows={4}
          maxRows={10}
        />
      );
    }
    return null;
  }

  if (isLoadingData)
    return <ContentSkeleton />;

  return (
    <>
      <Card>
        <CardHeader title="Create new project" />
        <CardBody>
          <div className="d-flex align-item-center">
            <div className="col-12">
              <MultiTabBlock
                multiTabContent={renderMultiTabContent}
                columns={projectColumns}
              />
            </div>
          </div>
        </CardBody>
      </Card>

      <div
        style={{ display: "flex", gap: "8px", justifyContent: "space-between" }}
      >
        <Button
          onClick={() => history.push("/projects")}
          variant="outlined"
          style={{ marginRight: 20 }}
        >
          Back
        </Button>

        {project.status === "review" && (
          <div style={{ display: "flex", gap: "20px" }}>
            <MuiThemeProvider theme={theme}>
              <Button
                key={buttonKey}
                onClick={() => setOpenConfirmDialog(3)}
                variant="outlined"
                color="secondary"
                style={{ marginLeft: "auto" }}
              >
                Reject project
              </Button>
            </MuiThemeProvider>
            <Button
              key={buttonKey}
              onClick={() => setOpenConfirmDialog(2)}
              variant="outlined"
              color="primary"
              style={{ marginLeft: "auto" }}
            >
              Accept project
            </Button>
          </div>
        )}
        {project.status === "published" && (
          <div style={{ display: "flex", gap: "20px" }}>
            {/*<MuiThemeProvider theme={theme}>
              <Button
                key={buttonKey}
                onClick={() => setOpenConfirmDialog(4)}
                variant="outlined"
                //color="secondary"
                style={{ marginLeft: "auto" }}
              >
                Change to draft
              </Button>
            </MuiThemeProvider>*/}
            <Button
              key={buttonKey}
              onClick={() => setOpenConfirmDialog(5)}
              variant="outlined"
              color="secondary"
              style={{ marginLeft: "auto" }}
            >
              Change to review
            </Button>
          </div>
        )}
      </div>

      <ConfirmDialog
        title={`Are you sure you want to accept this project?`}
        open={openConfirmDialog === 2}
        setOpen={setOpenConfirmDialog}
        children={projectDialog(project.validated)}
        DialogProps={{
          PaperProps: {
            style: project.validated
              ? {
                width: "50vw",
                height: "50vh",
                maxWidth: "none",
              }
              : {},
          },
        }}
        onConfirm={() => saveProject(true)}
      />

      <ConfirmDialog
        title={`What changes need this project to be accepted?`}
        open={openConfirmDialog === 3}
        setOpen={setOpenConfirmDialog}
        children={projectDialog(true)}
        DialogProps={{
          PaperProps: {
            style: project.validated
              ? {
                width: "50vw",
                height: "50vh",
                maxWidth: "none",
              }
              : {},
          },
        }}
        onConfirm={() => {
          project.descriptionRejected = descriptionRejected;
          saveProject(false);
        }}
      />

      <ConfirmDialog
        title={`Are your sure you want to change the status of the project to draft?`}
        open={openConfirmDialog === 4}
        setOpen={setOpenConfirmDialog}
        onConfirm={() => { saveProject(false); }}
      />
      <ConfirmDialog
        title={`Are your sure you want to change the status of the project to review?`}
        open={openConfirmDialog === 5}
        setOpen={setOpenConfirmDialog}
        onConfirm={() => {
          const copiaProject = { ...project };
          copiaProject.status = "review";

          if (projectId) {
            updateProject(projectId, copiaProject)
              .then((res) => {
                alertSuccess({
                  title: "Saved!",
                  customMessage: "Changes successfully saved.",
                });
                history.push("/projects");
              })
              .catch((error) => {
                alertError({
                  error: error,
                  customMessage: "Could not save changes.",
                });
              });
          }
        }}
      />
    </>
  );
}
